/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useCallback } from "react";
import { supabase } from "../supabaseClient";
import axios from "axios";
import toast from "react-hot-toast";
import { API_URL } from "../config";

// ─── Renk sabitleri (proje genelindeki dark-theme paleti) ───────────────────
const C = {
    bullish: "#16a34a",
    bearish: "#dc2626",
    bg:      "#0f172a",
    panel:   "#1e293b",
    border:  "#334155",
    text:    "#e2e8f0",
    muted:   "#94a3b8",
    accent:  "#3b82f6",
    warning: "#f59e0b",
    gold:    "#eab308",
    purple:  "#7c3aed",
};

const PIYASALAR = ["BIST", "Kripto"];

const YONLER = [
    { key: "AL",  label: "AL",  ikon: "📈" },
    { key: "SAT", label: "SAT", ikon: "📉" },
];

const AILELER = [
    { key: "A", label: "Bölge/Seviye",  ikon: "🧱" },
    { key: "B", label: "Yapısal Kırılım", ikon: "📐" },
    { key: "C", label: "Momentum/Zaman", ikon: "⏱️" },
    { key: "D", label: "Bileşik",        ikon: "🔗" },
    { key: "E", label: "Makro",          ikon: "🌐" },
];

// Aile ve Geçerlilik Skoru sütunlarının ne anlama geldiğini açıklayan metinler
// — sonuç tablosunun üstünde bilgi kartı olarak gösterilir.
const AILE_ACIKLAMA =
    "Aile, sinyalin hangi geçerlilik mantığıyla değerlendirildiğini gösterir: " +
    "A=Bölge/Seviye (fiyat kapanışla seviyeyi ihlal ederse geçersiz), " +
    "B=Yapısal Kırılım (ters yönde yeni kırılım oluşursa geçersiz), " +
    "C=Momentum/Zamana Duyarlı (kısa ömürlü, süre dolunca geçersiz), " +
    "D=Bileşik (alt sinyallerin durumuna ve hedef/stop seviyelerine bağlı), " +
    "E=Makro/Sürekli (yeni hesaplama bir öncekini otomatik geçersiz kılar).";

const GECERLILIK_ACIKLAMA =
    "Geçerlilik Skoru (0-100), sinyalin ne kadar hâlâ güvenilir olduğunu gösterir. " +
    "100 = tam geçerli/taze; piyasa rejimi, sektörel momentum veya haber duygusu " +
    "gibi 'yumuşak' faktörler sinyalin yönüne ters düştüğünde bu skor kademeli " +
    "olarak düşürülür (ama sinyal AKTİF kalmaya devam edebilir). Durum sert bir " +
    "eşiği (seviye ihlali, TTL aşımı vb.) temsil ederken, skor ince ayarlı bir " +
    "güven göstergesidir.";

const MODULLER = [
    "DIP", "LIKIDITE", "FVG", "CAPA", "OBBB", "IDM", "PD", "HACIM_PROFILI",
    "MSB", "TOPDOWN",
    "OTE", "SMT", "KILLZONE", "HACIM_AKISI", "DIVERGENCE",
    "COKLU", "ISLEM_PLANLAMA", "PUANLAMA", "KARAR_MOTORU", "BIRLESIK_SKOR", "YATIRIM_ONERISI",
    "PIYASA_REJIM", "SEKTOREL_ROTASYON", "HABER_DUYGU",
];

const DURUM_BILGI = {
    AKTIF:             { label: "Aktif",              renk: C.accent,  ikon: "🟢" },
    GECERSIZ:          { label: "Geçersiz",           renk: C.bearish, ikon: "⛔" },
    GERCEKLESTI_HEDEF: { label: "Gerçekleşti (Hedef)", renk: C.bullish, ikon: "🎯" },
    GERCEKLESTI_STOP:  { label: "Gerçekleşti (Stop)",  renk: C.warning, ikon: "🛑" },
    SURESI_DOLDU:      { label: "Süresi Doldu",       renk: C.muted,   ikon: "⏳" },
    BELIRSIZ:          { label: "Belirsiz",           renk: C.gold,    ikon: "❓" },
};

const NEDEN_LABEL = {
    SEVIYE_IHLALI:         "Seviye/Bölge İhlali",
    TERS_SINYAL:           "Ters Yönde Yeni Sinyal",
    YAPISAL_TERS_KIRILIM:  "Yapısal Ters Kırılım",
    HEDEF_GERCEKLESTI:     "Hedef Gerçekleşti",
    STOP_GERCEKLESTI:      "Stop Gerçekleşti",
    TTL_ASIMI:             "Maks. Yaşam Süresi Aşımı",
    KASKAD_GECERSIZ:       "Alt Sinyal Geçersizliği (Kaskad)",
    KAPSAM_DISI:           "Kapsam Dışına Çıktı",
    SUPERSEDED:            "Yeni Hesaplamayla Süperseded",
};

// ─── Yardımcı: token al ─────────────────────────────────────────────────────
async function getToken() {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) return null;
    if (session.expires_at * 1000 - Date.now() < 5 * 60 * 1000) {
        const { data } = await supabase.auth.refreshSession();
        return data.session?.access_token;
    }
    return session.access_token;
}

const fmt = (v, basamak = 4) => {
    if (v == null) return "—";
    const n = parseFloat(v);
    if (isNaN(n)) return "—";
    if (basamak === 0) return String(Math.round(n));
    // Sadece ondalık kısımdaki gereksiz sıfırları temizle (örn. "4.5000" -> "4.5"),
    // tam sayı kısmındaki sıfırlara DOKUNMA (önceki hali "100" -> "1" yapıyordu).
    return n.toFixed(basamak).replace(/(\.\d*?)0+$/, "$1").replace(/\.$/, "");
};

// Piyasaya göre varsayılan para birimi (para_birimi alanı boşsa düşülen son çare).
const paraBirimiVarsayilan = (piyasa) => (piyasa === "Kripto" ? "USD" : "TL");

// satir.para_birimi -> taramanın GERÇEKTEN yapıldığı para birimi (artık backend'den geliyor).
// Eski kayıtlarda bu alan boş olabilir; o durumda piyasa bazlı varsayılana düşülür.
const fmtFiyat = (v, satir, basamak = 4) => {
    if (v == null) return "—";
    const pb = satir?.para_birimi || paraBirimiVarsayilan(satir?.piyasa);
    return `${fmt(v, basamak)} ${pb}`;
};

const zamanFmt = (iso) => {
    if (!iso) return "—";
    const d = new Date(iso);
    return d.toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
};

// ─── Bilgi Kartı ─────────────────────────────────────────────────────────────
function BilgiKart({ ikon, baslik, deger, renk = C.accent, aktif, onClick }) {
    return (
        <div onClick={onClick} style={{
            background: C.panel, border: `1px solid ${aktif ? renk : C.border}`,
            borderRadius: 10, padding: "14px 18px", cursor: onClick ? "pointer" : "default",
            display: "flex", alignItems: "center", gap: 12, flex: 1, minWidth: 140,
            transition: "border-color 0.15s ease",
        }}>
            <span style={{ fontSize: 22 }}>{ikon}</span>
            <div>
                <div style={{ fontSize: 11, color: C.muted, marginBottom: 2 }}>{baslik}</div>
                <div style={{ fontSize: 20, fontWeight: 700, color: renk }}>{deger}</div>
            </div>
        </div>
    );
}

// ─── Geçerlilik Skoru Çubuğu ──────────────────────────────────────────────────
function GecerlilikCubugu({ skor }) {
    const renk = skor >= 70 ? C.bullish : skor >= 40 ? C.gold : C.bearish;
    return (
        <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 100 }}>
            <div style={{ flex: 1, height: 6, background: "#0f172a", borderRadius: 3, overflow: "hidden", border: `1px solid ${C.border}` }}>
                <div style={{ height: "100%", width: `${skor}%`, background: renk, borderRadius: 3, transition: "width 0.4s ease" }} />
            </div>
            <span style={{ fontSize: 12, fontWeight: 700, color: renk, minWidth: 30, textAlign: "right" }}>{fmt(skor, 0)}</span>
        </div>
    );
}

// ─── Bilgi İpucu (hover ile açılan açıklama kartı) ────────────────────────────
function BilgiIpucu({ metin }) {
    const [acik, setAcik] = useState(false);
    return (
        <span
            style={{ position: "relative", display: "inline-flex", marginLeft: 5, verticalAlign: "middle" }}
            onMouseEnter={() => setAcik(true)}
            onMouseLeave={() => setAcik(false)}
        >
            <span style={{
                display: "inline-flex", alignItems: "center", justifyContent: "center",
                width: 14, height: 14, borderRadius: "50%", border: `1px solid ${C.muted}`,
                color: C.muted, fontSize: 10, fontWeight: 700, cursor: "help", lineHeight: 1,
            }}>i</span>
            {acik && (
                <div style={{
                    position: "absolute", top: "150%", left: "50%", transform: "translateX(-50%)",
                    width: 260, background: "#0f172a", border: `1px solid ${C.border}`, borderRadius: 8,
                    padding: 10, fontSize: 11, fontWeight: 400, color: C.text, zIndex: 30,
                    boxShadow: "0 8px 24px rgba(0,0,0,0.45)", textAlign: "left", lineHeight: 1.5,
                    whiteSpace: "normal", textTransform: "none", letterSpacing: "normal",
                }}>
                    {metin}
                </div>
            )}
        </span>
    );
}

// ─── Durum Rozeti ─────────────────────────────────────────────────────────────
function DurumRozeti({ durum }) {
    const bilgi = DURUM_BILGI[durum] || { label: durum, renk: C.muted, ikon: "•" };
    return (
        <span style={{
            display: "inline-flex", alignItems: "center", gap: 5,
            padding: "3px 10px", borderRadius: 999, fontSize: 11, fontWeight: 700,
            background: bilgi.renk + "22", color: bilgi.renk, border: `1px solid ${bilgi.renk}55`,
            whiteSpace: "nowrap",
        }}>
            {bilgi.ikon} {bilgi.label}
        </span>
    );
}

// ─── Toggle Buton Grubu (native select/checkbox yerine) ──────────────────────
function ToggleGrubu({ secenekler, secili, onSec, hepsiEtiket = "Tümü" }) {
    return (
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
            <button onClick={() => onSec(null)} style={{
                padding: "7px 14px", borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: "pointer",
                border: `1px solid ${!secili ? C.accent : C.border}`,
                background: !secili ? C.accent + "22" : "#0f172a",
                color: !secili ? C.accent : C.muted,
            }}>{hepsiEtiket}</button>
            {secenekler.map((s) => {
                const key = typeof s === "string" ? s : s.key;
                const label = typeof s === "string" ? s : `${s.ikon} ${s.label}`;
                return (
                    <button key={key} onClick={() => onSec(key)} style={{
                        padding: "7px 14px", borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: "pointer",
                        border: `1px solid ${secili === key ? C.accent : C.border}`,
                        background: secili === key ? C.accent + "22" : "#0f172a",
                        color: secili === key ? C.accent : C.muted,
                    }}>{label}</button>
                );
            })}
        </div>
    );
}

// ─── Detay Paneli (slide-in) ──────────────────────────────────────────────────
function DetayPaneli({ satir, onKapat }) {
    if (!satir) return null;
    return (
        <div style={{
            position: "fixed", top: 0, right: 0, height: "100vh", width: 380, zIndex: 50,
            background: C.panel, borderLeft: `1px solid ${C.border}`, padding: 22,
            overflowY: "auto", boxShadow: "-8px 0 24px rgba(0,0,0,0.35)",
        }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18 }}>
                <div style={{ fontSize: 18, fontWeight: 700, color: C.text }}>{satir.sembol}</div>
                <button onClick={onKapat} style={{
                    background: "none", border: "none", color: C.muted, fontSize: 20, cursor: "pointer",
                }}>✕</button>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 12, fontSize: 13 }}>
                <Satir k="Modül"              v={satir.mod_kaynak} />
                <Satir k="Aile"                v={AILELER.find(a => a.key === satir.aile)?.label || satir.aile} />
                <Satir k="Piyasa"              v={satir.piyasa} />
                <Satir k="Yön"                 v={satir.yon || "—"} />
                <Satir k="Periyot"             v={satir.periyot || "—"} />
                <div style={{ borderTop: `1px solid ${C.border}`, margin: "6px 0" }} />
                <Satir k="Durum"               v={<DurumRozeti durum={satir.durum} />} />
                <Satir k="Geçerlilik Skoru"    v={<GecerlilikCubugu skor={satir.gecerlilik_skoru ?? 100} />} />
                {satir.gecersizlik_nedeni && (
                    <Satir k="Geçersizlik Nedeni" v={NEDEN_LABEL[satir.gecersizlik_nedeni] || satir.gecersizlik_nedeni} />
                )}
                <div style={{ borderTop: `1px solid ${C.border}`, margin: "6px 0" }} />
                <Satir k="Baz Fiyat"  v={fmtFiyat(satir.baz_fiyat, satir)} />
                {satir.seviye_alt != null && <Satir k="Seviye Alt" v={fmtFiyat(satir.seviye_alt, satir)} />}
                {satir.seviye_ust != null && <Satir k="Seviye Üst" v={fmtFiyat(satir.seviye_ust, satir)} />}
                {satir.hedef1 != null && <Satir k="Hedef 1" v={fmtFiyat(satir.hedef1, satir)} />}
                {satir.hedef2 != null && <Satir k="Hedef 2" v={fmtFiyat(satir.hedef2, satir)} />}
                {satir.stop_loss != null && <Satir k="Stop Loss" v={fmtFiyat(satir.stop_loss, satir)} />}
                <div style={{ borderTop: `1px solid ${C.border}`, margin: "6px 0" }} />
                <Satir k="Oluşturma"  v={zamanFmt(satir.olusturma_tarihi)} />
                <Satir k="Güncelleme" v={zamanFmt(satir.guncelleme_tarihi)} />
                {satir.gecersiz_tarihi && <Satir k="Geçersiz Olma" v={zamanFmt(satir.gecersiz_tarihi)} />}
            </div>
        </div>
    );
}

function Satir({ k, v }) {
    return (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10 }}>
            <span style={{ color: C.muted }}>{k}</span>
            <span style={{ color: C.text, fontWeight: 600, textAlign: "right" }}>{v}</span>
        </div>
    );
}

// ─── Ana Sayfa ────────────────────────────────────────────────────────────────
export default function SinyalYasamDongusu() {
    const [piyasa, setPiyasa]   = useState(null);
    const [aile, setAile]       = useState(null);
    const [modul, setModul]     = useState(null);
    const [yon, setYon]         = useState(null);
    const [durumFiltre, setDurumFiltre] = useState("AKTIF");

    const [ozet, setOzet]       = useState(null);
    const [kayitlar, setKayitlar] = useState([]);
    const [toplam, setToplam]   = useState(0);
    const [sayfa, setSayfa]     = useState(1);
    const SAYFA_BOYUTU = 50;

    const [yukleniyor, setYukleniyor] = useState(false);
    const [kontrolCalisiyor, setKontrolCalisiyor] = useState(false);
    const [seciliSatir, setSeciliSatir] = useState(null);

    const ozetGetir = useCallback(async () => {
        const token = await getToken();
        if (!token) return;
        try {
            const res = await axios.get(`${API_URL}/scan/sinyal-yasam-dongusu/ozet`, {
                params: { piyasa: piyasa || undefined },
                headers: { Authorization: `Bearer ${token}` },
            });
            setOzet(res.data);
        } catch (e) {
            console.error("Özet alınamadı:", e);
        }
    }, [piyasa]);

    const listeGetir = useCallback(async () => {
        const token = await getToken();
        if (!token) return;
        setYukleniyor(true);
        try {
            const res = await axios.get(`${API_URL}/scan/sinyal-yasam-dongusu/listele`, {
                params: {
                    piyasa: piyasa || undefined,
                    aile: aile || undefined,
                    mod_kaynak: modul || undefined,
                    yon: yon || undefined,
                    durum: durumFiltre || undefined,
                    sayfa, sayfa_boyutu: SAYFA_BOYUTU,
                },
                headers: { Authorization: `Bearer ${token}` },
            });
            setKayitlar(res.data.kayitlar || []);
            setToplam(res.data.toplam || 0);
        } catch (e) {
            console.error(e);
            toast.error("Sinyal listesi alınamadı.");
        } finally {
            setYukleniyor(false);
        }
    }, [piyasa, aile, modul, yon, durumFiltre, sayfa]);

    useEffect(() => { setSayfa(1); }, [piyasa, aile, modul, yon, durumFiltre]);
    useEffect(() => { listeGetir(); }, [listeGetir]);
    useEffect(() => { ozetGetir(); }, [ozetGetir]);

    const manuelKontrol = async () => {
        const token = await getToken();
        if (!token) return;
        setKontrolCalisiyor(true);
        try {
            const res = await axios.post(`${API_URL}/scan/sinyal-yasam-dongusu/kontrol`, {},
                { headers: { Authorization: `Bearer ${token}` } });
            const s = res.data;
            toast.success(
                `✅ Kontrol tamam — ${s.kontrol_edilen} sinyal tarandı, ` +
                `${s.gecersiz} geçersiz, ${s.gerceklesti} gerçekleşti, ${s.suresi_doldu} süresi doldu`
            );
            listeGetir();
            ozetGetir();
        } catch (e) {
            console.error(e);
            toast.error("Kontrol çalıştırılamadı.");
        } finally {
            setKontrolCalisiyor(false);
        }
    };

    const toplamSayfa = Math.max(1, Math.ceil(toplam / SAYFA_BOYUTU));

    return (
        <div style={{ background: C.bg, minHeight: "100vh", padding: 24, color: C.text }}>
            {/* Başlık */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20, flexWrap: "wrap", gap: 12 }}>
                <div>
                    <div style={{ fontSize: 22, fontWeight: 700 }}>🔄 Sinyal Yaşam Döngüsü</div>
                    <div style={{ fontSize: 13, color: C.muted, marginTop: 2 }}>
                        Aktif sinyallerin canlı geçerlilik durumu — Doğruluk Analizi'nden bağımsız, skor üreten modüllerin girdi katmanı
                    </div>
                </div>
                <button onClick={manuelKontrol} disabled={kontrolCalisiyor} style={{
                    padding: "10px 20px", borderRadius: 8,
                    background: kontrolCalisiyor ? "#334155" : C.accent,
                    border: "none", color: "white", fontWeight: 700, fontSize: 13,
                    cursor: kontrolCalisiyor ? "not-allowed" : "pointer",
                }}>
                    {kontrolCalisiyor ? "⏳ Kontrol Ediliyor..." : "🔍 Şimdi Kontrol Et"}
                </button>
            </div>

            {/* Özet Kartları */}
            {ozet && (
                <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 20 }}>
                    <BilgiKart ikon="🟢" baslik="Aktif" deger={ozet.AKTIF}
                        renk={C.accent} aktif={durumFiltre === "AKTIF"} onClick={() => setDurumFiltre("AKTIF")} />
                    <BilgiKart ikon="⛔" baslik="Geçersiz" deger={ozet.GECERSIZ}
                        renk={C.bearish} aktif={durumFiltre === "GECERSIZ"} onClick={() => setDurumFiltre("GECERSIZ")} />
                    <BilgiKart ikon="🎯" baslik="Hedef Gerçekleşti" deger={ozet.GERCEKLESTI_HEDEF}
                        renk={C.bullish} aktif={durumFiltre === "GERCEKLESTI_HEDEF"} onClick={() => setDurumFiltre("GERCEKLESTI_HEDEF")} />
                    <BilgiKart ikon="🛑" baslik="Stop Gerçekleşti" deger={ozet.GERCEKLESTI_STOP}
                        renk={C.warning} aktif={durumFiltre === "GERCEKLESTI_STOP"} onClick={() => setDurumFiltre("GERCEKLESTI_STOP")} />
                    <BilgiKart ikon="⏳" baslik="Süresi Doldu" deger={ozet.SURESI_DOLDU}
                        renk={C.muted} aktif={durumFiltre === "SURESI_DOLDU"} onClick={() => setDurumFiltre("SURESI_DOLDU")} />
                    <BilgiKart ikon="❓" baslik="Belirsiz" deger={ozet.BELIRSIZ}
                        renk={C.gold} aktif={durumFiltre === "BELIRSIZ"} onClick={() => setDurumFiltre("BELIRSIZ")} />
                    <BilgiKart ikon="📊" baslik="Son 24s Kapanan" deger={ozet.son_24s_kapanan} renk={C.purple} />
                </div>
            )}

            {/* Filtreler */}
            <div style={{ background: C.panel, border: `1px solid ${C.border}`, borderRadius: 10, padding: 16, marginBottom: 16, display: "flex", flexDirection: "column", gap: 14 }}>
                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                    <label style={{ fontSize: 11, color: C.muted, fontWeight: 600, letterSpacing: "0.05em" }}>PİYASA</label>
                    <ToggleGrubu secenekler={PIYASALAR} secili={piyasa} onSec={setPiyasa} />
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                    <label style={{ fontSize: 11, color: C.muted, fontWeight: 600, letterSpacing: "0.05em" }}>AİLE</label>
                    <ToggleGrubu secenekler={AILELER} secili={aile} onSec={setAile} />
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                    <label style={{ fontSize: 11, color: C.muted, fontWeight: 600, letterSpacing: "0.05em" }}>YÖN</label>
                    <ToggleGrubu secenekler={YONLER} secili={yon} onSec={setYon} />
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                    <label style={{ fontSize: 11, color: C.muted, fontWeight: 600, letterSpacing: "0.05em" }}>MODÜL</label>
                    <div style={{ maxHeight: 74, overflowY: "auto" }}>
                        <ToggleGrubu secenekler={MODULLER} secili={modul} onSec={setModul} />
                    </div>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                    <label style={{ fontSize: 11, color: C.muted, fontWeight: 600, letterSpacing: "0.05em" }}>DURUM</label>
                    <ToggleGrubu secenekler={Object.keys(DURUM_BILGI)} secili={durumFiltre}
                        onSec={setDurumFiltre} hepsiEtiket="Tümü" />
                </div>
            </div>

            {/* Tablo */}
            <div style={{ background: C.panel, border: `1px solid ${C.border}`, borderRadius: 10, overflow: "hidden" }}>
                <div style={{ overflowX: "auto" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                        <thead>
                            <tr style={{ background: "#0f172a", color: C.muted, textAlign: "left" }}>
                                {["Sembol", "Modül"].map(h => (
                                    <th key={h} style={{ padding: "10px 14px", fontWeight: 600, fontSize: 11, letterSpacing: "0.03em", borderBottom: `1px solid ${C.border}` }}>{h}</th>
                                ))}
                                <th style={{ padding: "10px 14px", fontWeight: 600, fontSize: 11, letterSpacing: "0.03em", borderBottom: `1px solid ${C.border}` }}>
                                    Aile<BilgiIpucu metin={AILE_ACIKLAMA} />
                                </th>
                                {["Piyasa", "Yön", "Durum"].map(h => (
                                    <th key={h} style={{ padding: "10px 14px", fontWeight: 600, fontSize: 11, letterSpacing: "0.03em", borderBottom: `1px solid ${C.border}` }}>{h}</th>
                                ))}
                                <th style={{ padding: "10px 14px", fontWeight: 600, fontSize: 11, letterSpacing: "0.03em", borderBottom: `1px solid ${C.border}` }}>
                                    Geçerlilik<BilgiIpucu metin={GECERLILIK_ACIKLAMA} />
                                </th>
                                {["Neden", "Güncelleme"].map(h => (
                                    <th key={h} style={{ padding: "10px 14px", fontWeight: 600, fontSize: 11, letterSpacing: "0.03em", borderBottom: `1px solid ${C.border}` }}>{h}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {yukleniyor ? (
                                <tr><td colSpan={9} style={{ padding: 24, textAlign: "center", color: C.muted }}>⏳ Yükleniyor...</td></tr>
                            ) : kayitlar.length === 0 ? (
                                <tr><td colSpan={9} style={{ padding: 24, textAlign: "center", color: C.muted }}>Bu filtrelerle kayıt bulunamadı.</td></tr>
                            ) : kayitlar.map((r) => (
                                <tr key={r.id} onClick={() => setSeciliSatir(r)} style={{
                                    borderBottom: `1px solid ${C.border}`, cursor: "pointer",
                                }}
                                    onMouseEnter={e => e.currentTarget.style.background = "#0f172a55"}
                                    onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                                >
                                    <td style={{ padding: "10px 14px", fontWeight: 700 }}>{r.sembol}</td>
                                    <td style={{ padding: "10px 14px", color: C.muted }}>{r.mod_kaynak}</td>
                                    <td style={{ padding: "10px 14px", color: C.muted }}>{r.aile}</td>
                                    <td style={{ padding: "10px 14px", color: C.muted }}>{r.piyasa}</td>
                                    <td style={{ padding: "10px 14px", color: r.yon === "SAT" ? C.bearish : r.yon === "AL" ? C.bullish : C.muted }}>{r.yon || "—"}</td>
                                    <td style={{ padding: "10px 14px" }}><DurumRozeti durum={r.durum} /></td>
                                    <td style={{ padding: "10px 14px" }}><GecerlilikCubugu skor={r.gecerlilik_skoru ?? 100} /></td>
                                    <td style={{ padding: "10px 14px", color: C.muted, fontSize: 12 }}>{NEDEN_LABEL[r.gecersizlik_nedeni] || "—"}</td>
                                    <td style={{ padding: "10px 14px", color: C.muted, fontSize: 12 }}>{zamanFmt(r.guncelleme_tarihi)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Sayfalama */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: 14, borderTop: `1px solid ${C.border}` }}>
                    <span style={{ fontSize: 12, color: C.muted }}>Toplam {toplam} kayıt</span>
                    <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                        <button onClick={() => setSayfa(s => Math.max(1, s - 1))} disabled={sayfa <= 1} style={{
                            padding: "6px 12px", borderRadius: 6, border: `1px solid ${C.border}`, background: "#0f172a",
                            color: sayfa <= 1 ? C.border : C.text, cursor: sayfa <= 1 ? "not-allowed" : "pointer", fontSize: 12,
                        }}>◀ Önceki</button>
                        <span style={{ fontSize: 12, color: C.muted }}>{sayfa} / {toplamSayfa}</span>
                        <button onClick={() => setSayfa(s => Math.min(toplamSayfa, s + 1))} disabled={sayfa >= toplamSayfa} style={{
                            padding: "6px 12px", borderRadius: 6, border: `1px solid ${C.border}`, background: "#0f172a",
                            color: sayfa >= toplamSayfa ? C.border : C.text, cursor: sayfa >= toplamSayfa ? "not-allowed" : "pointer", fontSize: 12,
                        }}>Sonraki ▶</button>
                    </div>
                </div>
            </div>

            <DetayPaneli satir={seciliSatir} onKapat={() => setSeciliSatir(null)} />
        </div>
    );
}
